import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";

import { AiOutlineMenuUnfold } from "react-icons/ai";
import { keyframes } from "@emotion/react";
import { useTheme } from "@mui/material/styles";

const scrollText = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const HeaderContent = ({ handleOpen }) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery((theme) => theme?.breakpoints?.down("md"));
  const originUrl = window.location.origin;
  const envOrigins = [
    { url: "https://devnctc.nativecoders.se/", env: "Dev" },
    { url: "http://localhost:3000", env: "Local" },
    // { url: "https://qa-nctc.nativecode.com", env: "UAT" }, //UAT environment
  ];

  const [currentOrigin, setCorrentOrigin] = useState("");

  useEffect(() => {
    const env = envOrigins.filter((item) => item?.url === originUrl);
    setCorrentOrigin(env[0]?.env);
  }, []);

  const iconBackColor = theme?.palette?.mode === "dark" ? "background.default" : "grey.100";

  return (
    <>
      {currentOrigin && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "300px",
            height: "30px",
            backgroundColor: "rgba(242, 72, 34, 0.2)",
            border: "1px solid #F24822",
            borderRadius: "20px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
            whiteSpace: "nowrap",
            ml: 2,
            mt: 0.3,
          }}>
          <Typography
            sx={{
              color: "#F24822",
              fontSize: "12px",
              fontWeight: "bold",
              textTransform: "uppercase",
              animation: `${scrollText} 7s linear infinite`,
            }}>
            You are in the {currentOrigin} environment.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default HeaderContent;